// extracted by mini-css-extract-plugin
module.exports = {"successCard":"pages-successPage-successCard-d82d57f1"};